import { DictionariesService, DictionaryItem } from "@sa/rep-mdm";
import { orderBy } from "lodash";
import { SLIDE_NUMBER } from "../constants";

export async function getCountriesSelection(calendar: number, commodity: number, businessUnit: number, dictionariesService: DictionariesService) {
  const topCountriesDictionary = await dictionariesService.getDictionary({
    id: 'slides-countries-slide24',
    parameters: {
      p_commodity: commodity,
      p_calendar: String(calendar),
      p_business_unit: businessUnit,
      p_countries: '',
    },
  });
  const slideDisplayCountriesDictionary = await dictionariesService.getDictionary({
    id: "slides-countries-display",
    parameters: {
      slide: SLIDE_NUMBER,
      olap_commodity: commodity,
      business_unit: businessUnit,
    },
  }); 
  const topCountriesItems$ = topCountriesDictionary.getAll();
  const slideDisplayCountriesItems$ = slideDisplayCountriesDictionary.getAll();

  const [topCountriesItems, slideDisplayCountriesItems] = await Promise.all([topCountriesItems$, slideDisplayCountriesItems$]);

  const countriesRelationship = new Map(slideDisplayCountriesItems.map(item => ([item.getValue<number>('olap_country'), Number(item.id)])));

  const filterSlideItems = (item : DictionaryItem) => countriesRelationship.has(Number(item.id));
  const filtredCountriesItems = topCountriesItems.filter(filterSlideItems).slice(0, 13);
  const countriesDisplay = filtredCountriesItems.map(item => countriesRelationship.get(Number(item.id)));
  const countries = filtredCountriesItems.map(item => Number(item.id));

  return {countries, countriesDisplay};
}